import { lazy } from 'solid-js'
import { messages } from '../../pages/newsroom-article-page/newsroom-article-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/newsroom-article-page/newsroom-article-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/newsroom/:slug',
    titleMessage: messages.titleMessage,
}
